<template>
    <div class="container remove-padding">
        <div class="header-top bg-white">
            <div class="nav-center">
                <div class="row set-row d-flex w-limit">
                    <div class="remove-padding navbar-icon-left" @click="back">
                        <img class="remove-padding-margin" @click="" src="../../assets/gambar/back-blue.svg">
                    </div>
                    <div class="text-center remove-padding flex-1 font-weight-600">
                        Ubah Rak
                    </div>
                    <div class="navbar-icon-right remove-padding">

                    </div>
                </div>
            </div>
        </div>
        <main class="add-padding-default w-limit">
            <div class="flex-100">
                <div class="flex-1 pad-top-66">
                    <form action="">
                        <div class="form-group animated">
                            <label class="remove-margin color-6f7 font-14 require" for="namaeditrak">Nama Rak</label>
                            <input type="text" class="form-control inputs" id="namaeditrak" aria-describedby="emailHelp"
                                   placeholder="Clean Laundry" v-model="namarakedit" v-on:keyup="inputnamarakedit">
	                        <ErrorMessage class="error" label="Nama Rak" :validation="$v.namarakedit"></ErrorMessage>
	                        
	                        <div class="form-group animated" id="more">
                                <label class="remove-margin mar-top-20 require">Kategori Rak</label>
                                <select class="form-control tagging" id="suggestDataRak" multiple="true"  v-on:keyup="cekValidate">
                                    <option v-if="suggestarrayeditrak !==0 && optionrak.text === tagrak[0].nama" selected v-for="optionrak in suggestarrayeditrak">
                                        {{ optionrak.text }}
                                    </option>
                                    <option v-if="suggestarrayeditrak !==0 && optionrak.text !== tagrak[0].nama" v-for="optionrak in suggestarrayeditrak">
                                        {{ optionrak.text }}
                                    </option>
                                </select>
		                        <ErrorMessage class="error" label="Kategori Rak" :validation="$v.kategoriRak"></ErrorMessage>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="button-lanjut ">
                    <button class="btn btn-login btn-long remove-margin" id="BtnEditrak" @click="checktagrakedit">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                              v-if="isClicked === true"></span><span id="textBtnEditrak">Simpan</span>
                    </button>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
    import Select2 from 'v-select2-component';
    import ErrorMessage from "@/component-items/ErrorMessage";
    import {minLength, required} from "vuelidate/lib/validators";
    
    export default {
        name: "EditRak",
        props:['setidoutletserak','dataidrak'],
        components: {Select2,ErrorMessage},
        data(){
            return{
                suggestarrayeditrak:[],
                namarakedit:'',
                tagrak:[],
                isClicked:false,
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                },
	            kategoriRak: "",
            }
        },
	    validations: {
		    namarakedit: {
		    	required,
			    minLength: minLength(2)
		    },
		    kategoriRak: {
		    	required
		    }
	    },
        mounted() {
            this.tagging();
            // this.getdetailrak();
            // this.suggestrak();
            this.getDataSelect()

            this.backButtonPressed(this.back)
        },
        methods:{
            back(){
                this.$emit('back')
            },
	        onchangeKategoriRak() {
		        $("#suggestDataRak").change(() => {
			        this.kategoriRak = $("#suggestDataRak").val()[0];
		        })
	        },

            tagging(){
                $(".tagging").select2({
                    placeholder: "Ketuk Untuk Menambah Tag", //placeholder
                    tags: true,
                    maximumSelectionLength: 1,
                });
                // this.cekValidate()
            },

            inputnamarakedit(event){
                var handleevent = event.target.value;
                var handle = handleevent.replace(/[^0-9A-Za-z.,' -]+/,'');
                this.namarakedit = handle;
                this.cekValidate()
            },


            cekValidate(){
            	return
                var NamaLayanan = this.namarakedit;
                var lenPass = NamaLayanan.length;
                if (lenPass >= 2) {
                    $('#BtnEditrak').prop('disabled', false);
                } else {
                    $('#BtnEditrak').prop('disabled', true);
                }
            },

            async getDataSelect(){
                await this.getdetailrak();
                await this.suggestrak();
            },

            async getdetailrak(){
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/detail_rak_meta?idrak=' + this.dataidrak.idrak,this.requestHeaders)
                    if(response.data.status===true){
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                        var detailrak = response.data.data;
                        this.namarakedit= detailrak.nama;
	                    this.kategoriRak = detailrak.rak_kategori !== null ? detailrak.rak_kategori.nama : ""
                        this.tagrak.push(detailrak.rak_kategori)
                        $('#suggestDataRak').val(this.tagrak).trigger('change');
                        this.cekValidate()
	                    this.onchangeKategoriRak()
                    }
                }catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },

            async suggestrak(){
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/suggest_kategori_rak?idoutlet=' + this.setidoutletserak, this.requestHeaders)
                    if(response.status===200){
                        if (response.data.status===true){
                            $('#loadingPage').hide();
                            $('#loadingPage').removeClass('overlayLoading');
                            var suggest = response.data.data
                            for ( var i = 0; i < suggest.length; i++){
                                this.suggestarrayeditrak.push({idtags: suggest[i].idtags, text: suggest[i].nama})
                            }
                        }
                    }
                }catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },

	        errorValidation() {
		        this.$v.namarakedit.$touch()
		        this.$v.kategoriRak.$touch()
		        return this.$v.namarakedit.$invalid || this.$v.kategoriRak.$invalid
	        },
            checktagrakedit(){
            	if (this.errorValidation()) {
		            this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
            		return
	            }
                this.isClicked = true;
                $('#textBtnEditrak').hide()
                $('#BtnEditrak').prop('disabled', true);
                var suggesnapval = $("#suggestDataRak").select2('data');
                var lenghtArray = suggesnapval.length;

                if(lenghtArray>0){
                    this.editrak()
                    this.isClicked = false;
                    $('#textBtnEditrak').show()
                    $('#BtnEditrak').prop('disabled', false);
                }else{
                    this.isClicked = false;
                    $('#textBtnEditrak').show()
                    $('#BtnEditrak').prop('disabled', false);
                    this.$toast.error("Tag Mesin Tidak Boleh Kosong")
                }
            },

            async editrak(){
                this.isClicked = true;
                $('#textBtnEditrak').hide()
                $('#BtnEditrak').prop('disabled', true);
                var dataTagsrak = $("#suggestDataRak").select2('data')
                try {
                    const editrak = new FormData()
                    editrak.append('nama_rak', this.namarakedit);
                    editrak.append('nama_kategori',dataTagsrak[0].text);
                    const response = await this.$axios.post(this.$baseurl + '/masterData/rak/update_rak?idrak=' + this.dataidrak.idrak + '&idoutlet=' + this.setidoutletserak , editrak, this.requestHeaders);
                    if(response.data.status===true){
                        this.isClicked = false;
                        $('#textBtnEditrak').show()
                        $('#BtnEditrak').prop('disabled', false);
                        this.back()
                        this.namarakedit='';
                        this.$toast.success(response.data.msg)
                    }else{
                        this.isClicked = false;
                        $('#textBtnEditrak').show()
                        $('#BtnEditrak').prop('disabled', false);
                        this.$toast.error(response.data.msg)
                    }
                }  catch (e) {
                	this.$catch_error_response(e)
	                this.isClicked = false;
	                $('#textBtnEditrak').show()
	                $('#BtnEditrak').prop('disabled', false);
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },
        }
    }
</script>

<style scoped>

</style>